// js/foods/ui-food-create-panel.js
import { setSetupStage, persistSetupStage } from '../setup/setup-stage-manager.js';
import { createPanelController } from '../shared/ui-panel-base.js';
import { setFoods } from '../state-manager.js';
import { createClientFoods, loadClientFoods } from '../requests/foods.js';
import {
  pendingFoods,
  addFood,
  resetFoodForm,
  renderFoodPreview,
  populateProfilesSelect
} from './ui-settings-food-form.js';
import { closePanel } from '../shared/ui-panel-controller.js';

export const createFoodPanel = createPanelController('settings-food-create', {
  onOpen: () => {
    pendingFoods.length = 0;
    resetFoodForm();
    renderFoodPreview();
    populateProfilesSelect();
  },
  onClose: () => {
    pendingFoods.length = 0;
  },
});

document.getElementById('settings-add-food')?.addEventListener('click', () => {
  const name = document.getElementById('settings-food-name')?.value.trim();
  const weight = document.getElementById('settings-food-weight')?.value;
  let barcode = document.getElementById('settings-food-barcode')?.value;
  const selected = document.getElementById('settings-food-profile-ids')?.selectedOptions;
  const profileIds = Array.from(selected).map(opt => opt.value);
  
  barcode = barcode.trim() === '' ? '1234567890' : barcode.trim();
  addFood({ name, weight, barcode, profileIds });
  renderFoodPreview();
  resetFoodForm();
});

document.getElementById('settings-submit-foods')?.addEventListener('click', async () => {
  if (pendingFoods.length === 0) return alert('Add some food first.');

  const payload = pendingFoods.map(f => ({
    name: f.name,
    weight: f.weight,
    barcode: f.barcode,
    profile_ids: f.profileIds,
  }));

  try {
    const result = await createClientFoods(payload);
    if (result.success) {
      const updated = await loadClientFoods();
      setFoods(updated);
      setSetupStage({ foodsCreated: true });
      createFoodPanel.close();
      createFoodPanel.onSubmitSuccess?.();
    } else {
      alert('Failed to create foods.');
    }
  } catch (err) {
    console.error('[FoodCreatePanel] Error:', err);
    alert('Something went wrong.');
  }
});

document.querySelector('#settings-food-create-sheet .back-btn')?.addEventListener('click', () => {
  console.log('[FoodCreatePanel] Back to settings from food create panel');
  closePanel('settings-food-create'); // Will automatically restore previous panel (e.g. settings)
});  
